/**
 * URL route constants for the App Updates application
 */

export const ROUTES = {
  /**
   * Base route for the app updates list page
   */
  RELEASE_NOTES: '/release-notes',

  /**
   * Route for app update details page
   * @param id - The update ID
   * @returns The complete route path
   */
  RELEASE_NOTE_DETAILS: (id: string) => `/release-notes/${id}`,
} as const;
